import React from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import Select, { components } from 'react-select';
// import InfoTooltip from '../infoTooltip/InfoToolTip';

interface CustomSelectComponentProps {
    control?: Control<any>;
    label?: any;
    name: string;
    placeholder: string;
    required?: boolean;
    disabled?: boolean;
    defaultValue?: any;
    options?: { key: string; name: string }[];
    errors?: FieldErrors<any>;
    errorTitle?: string;
    value?: any;
    isPartnerType?: boolean;
}

const CustomDropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99992 11.9838C9.90992 11.9838 9.82714 11.969 9.75158 11.9396C9.67603 11.9101 9.60186 11.859 9.52908 11.7863L5.87158 8.12958C5.79381 8.05181 5.75214 7.95625 5.74658 7.84292C5.74103 7.72958 5.7827 7.62847 5.87158 7.53958C5.96047 7.45069 6.05881 7.40625 6.16658 7.40625C6.27436 7.40625 6.3727 7.45069 6.46158 7.53958L9.99992 11.0779L13.5383 7.53958C13.616 7.46181 13.7116 7.42014 13.8249 7.41458C13.9383 7.40903 14.0394 7.45069 14.1283 7.53958C14.2171 7.62847 14.2616 7.72681 14.2616 7.83458C14.2616 7.94236 14.2171 8.04069 14.1283 8.12958L10.4708 11.7863C10.3985 11.859 10.3244 11.9101 10.2483 11.9396C10.1727 11.969 10.0899 11.9838 9.99992 11.9838Z" fill="#003764" />
            </svg>

        </components.DropdownIndicator>
    );
};

const customStyles = (disabled: boolean) => ({
    control: (provided: any) => ({
        ...provided,
        fontSize: '1rem',
        fontWeight: 400,
        color: '#003764',
        height: '2.3rem',
        border: '0.0625rem solid #ededed',
        borderRadius: '4px',
        boxShadow: 'none', // Remove default shadow on focus
        backgroundColor: disabled ? '#f1f2f5' : '#FFFFFF', // Conditional backgroundColor
        ':hover': {
            borderColor: '#ededed' // Maintain the same border color on hover
        }
    }),
    singleValue: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: disabled ? '#f1f2f5' : '#FFFFFF',
        color: disabled ? '#a7a9bc' : '#003764'
    }),
    option: (provided: any, state: any) => ({
        ...provided,
        fontSize: '14px',
        backgroundColor: state.isSelected ? '#003764' : '#fff',
        color: state.isSelected ? '#fff' : '#003764',
        padding: '5.5px 16px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        ':hover': {
            color: '#fff',
            backgroundColor: '#0069d9'
        }
    }),
    menu: (provided: any) => ({
        ...provided,
        fontSize: '14px',
        borderRadius: '4px',
        zIndex: 100
    }),
    placeholder: (provided: any) => ({
        ...provided,
        fontSize: '1rem',
        color: '#C9C9C9'
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        color: '#003764',
        ':hover': {
            color: '#003764'
        },
        padding: '4px'
    }),
    indicatorSeparator: (provided: any) => ({
        ...provided,
        display: 'none'
    })
});


const CustomSelect: React.FC<CustomSelectComponentProps> = ({
    label,
    name,
    placeholder,
    control,
    required,
    disabled,
    defaultValue,
    options,
    errors,
    errorTitle,
    isPartnerType
}) => {
    const formattedOptions =
        options?.map((option) => ({
            value: option.key,
            label: option.name,
        })) || [];
    return (
        <div className="form-group">
            {label && (
                <label htmlFor={name}>
                    {(() => {
                        if (isPartnerType) {
                            return <span>{label}</span>;
                        } else {
                            return label;
                        }
                    })()}
                </label>
            )}
            <Controller
                control={control}
                name={name}
                defaultValue={defaultValue}
                rules={{
                    required: required && `${errorTitle} is required`,
                }}
                render={({ field: { onChange, value } }) => (
                    <Select
                        id={name}
                        name={name}
                        value={
                            formattedOptions.find(
                                (option) => option.value === value
                            ) || null
                        }
                        onChange={(selectedOption) =>
                            onChange(selectedOption?.value)
                        }
                        components={{ DropdownIndicator: CustomDropdownIndicator }}
                        options={formattedOptions}
                        isDisabled={disabled}
                        placeholder={placeholder}
                        styles={customStyles(disabled || false)}
                    />
                )}
            />
            {errors && errors[name] && (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                    {errors[name]?.message as string}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;